// extracted by mini-css-extract-plugin
export default {"root":"Badge_root_Mpq8U","success":"Badge_success_jJCan","warning":"Badge_warning__ZiS7","danger":"Badge_danger_mYcSx","primary":"Badge_primary_NtgXh","small":"Badge_small_bfVkk"};